import { Navigate, useParams, useSearchParams } from "react-router";
import { MqttMeterReadingsTable } from "@/components/mqtt/mqtt-meter-readings-table";
import { isValidLang, ROUTE_SLUGS } from "@/config/routes";

export function MqttMeterReadingsPage() {
	const { sn, readingId, lang } = useParams<{
		sn: string;
		readingId: string;
		lang: string;
	}>();
	const [searchParams] = useSearchParams();
	const districtId = Number(searchParams.get("district"));
	const readingIdNum = Number(readingId);
	const currentLang = lang && isValidLang(lang) ? lang : "pl";

	if (!sn || !districtId || !readingIdNum) {
		return (
			<Navigate
				to={`/${currentLang}/${ROUTE_SLUGS.sources[currentLang]}`}
				replace
			/>
		);
	}

	return (
		<div className="flex flex-1 flex-col gap-4 p-4 lg:p-6">
			<MqttMeterReadingsTable
				districtId={districtId}
				readingId={readingIdNum}
			/>
		</div>
	);
}
